<span [matMenuTriggerFor]="menu"></span>

<ng-container>
  <mat-menu #menu="matMenu" (closed)="onMenuClosed.emit()" [overlapTrigger]="true">
    <div class="wrapper p-2" (click)="click($event)">
      <header class="row-flex row-flex--between mx-0">
        <h3>{{ 'Work' | translate }}</h3>
        <span class="close-btn" (click)="closeMenu()"><i class="icon icon-close_ico"></i></span>
      </header>

      <section class="work-detail my-1" *ngIf="!(workItem.loading$ | async); else loading">
        <div class="work-detail-row">
          <i class="icon icon-Project"></i>
          <span *ngIf="workItem?.data?.project; else noSet" class="info"> {{ workItem.data.project.name }}</span>
        </div>
        <div class="work-detail-row">
          <i class="icon icon-Clients"></i>
          <span *ngIf="workItem?.data?.client; else noSet" class="info">{{ workItem.data.client.name }}</span>
        </div>
        <div *ngIf="workItem?.data?.task" class="work-detail-row">
          <i class="icon icon-task"></i
          ><!-- TODO: change icon -->
          <span class="info">{{ workItem.data.task.name }}</span>
        </div>
        <div class="work-detail-row">
          <i class="icon icon-Time"></i>
          <div class="row-flex row-flex--column mx-0">
            <span class="info">{{ workItem?.data?.date | projectDetailDateFormat: 'ddd MMM' : lang }}</span>
            <span class="info">{{ workItem?.data?.mappedDuration || 'No set' }}</span>
          </div>
        </div>
        <div *ngIf="workItem?.data?.lunchTimeConverted" class="work-detail-row">
          <i class="icon icon-Time"></i>
          <span class="info">{{ 'Lunch' | translate }} - {{ workItem.data.lunchTimeConverted }} {{ 'min' | translate }}</span>
        </div>
        <div class="work-detail-row">
          <i class="icon icon-Address_ico"></i>
          <span *ngIf="workItem?.data?.project?.project_location?.address; else noSet" class="info">
            {{ workItem.data.project.project_location.address }}</span
          >
        </div>
        <div class="my-1" *ngIf="workItem?.data?.project?.project_location?.address">
          <btn-action
            withIcon="true"
            iconClass="icon-Google_maps_ico mx-1"
            styleClasses="black text-sm"
            [buttonLabel]="'Open in Google maps' | translate"
            [uppercase]="true"
            (applyAction)="openMapPage()">
          </btn-action>
        </div>
        <div class="work-detail-row">
          <i class="icon icon-Calendar"></i>
          <span class="info">
            <ng-container *ngIf="workItem?.data?.notes; else noSet">
              {{ workItem?.data?.notes }}
            </ng-container>
          </span>
        </div>
      </section>

      <div
        *ngIf="!(workItem.loading$ | async) && (isAdmin || isManager) && showEdit"
        class="row-flex row-flex--between row-flex--middle mx-0">
        <button class="action-item" (click)="delete()">
          <span class="icon-wrap">
            <i class="icon icon-Delete_ico" [matTooltip]="'Delete' | translate"></i>
          </span>
        </button>

        <btn-action
          styleClasses="black"
          iconClass="icon-Edit"
          [withIcon]="true"
          [buttonLabel]="'Edit' | translate"
          (applyAction)="edit()">
        </btn-action>
      </div>

      <div *ngIf="!(workItem.loading$ | async) && showLogHours && showLogHoursBtn" class="log-btn-wrapper mt-2">
        <btn-action
          styleClasses="edit green-color"
          buttonLabel="{{ 'Log hours' | translate }}"
          [withIcon]="true"
          iconClass="icon-Time"
          (applyAction)="openLogTimeSidePanel($event)">
        </btn-action>
      </div>
    </div>
  </mat-menu>
</ng-container>

<ng-template #loading>
  <loader [loading]="workItem.loading$"></loader>
</ng-template>

<ng-template #noSet>
  <span class="not-set" translate> Not set</span>
</ng-template>
